import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './community-rules-safety.css'

const CommunityRulesSafety = (props) => {
  return (
    <div className="community-rules-safety-container10">
      <Helmet>
        <title>Community-Rules-Safety - Dogeet</title>
        <meta
          property="og:title"
          content="Community-Rules-Safety - Dogeet"
        />
        <link
          rel="canonical"
          href="https://dogeet.com/community-rules-safety"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-overlay-media">
        <div className="hero-media-wrapper">
          <img
            src="https://images.pexels.com/photos/16817337/pexels-photo-16817337.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            alt="Dogeet Community Market"
            className="community-rules---safety-hero-bg-image hero-bg-image"
          />
          <div className="hero-scrim-overlay"></div>
        </div>
        <div className="community-rules---safety-hero-content-container">
          <div className="community-rules---safety-hero-text-block">
            <h1 className="hero-title">Community Rules &amp; Safety</h1>
            <p className="hero-subtitle">
              Much safety. Very local. Such community. Welcome to the Dogeet
              Bazaar, where we keep the vibes high and the scams low. Our
              moderation philosophy is simple: be a good shibe, trade local, and
              respect the DOGE.
            </p>
            <div className="hero-cta-group">
              <a href="#reporting">
                <div className="btn btn-primary">
                  <span>Report an Issue</span>
                </div>
              </a>
              <a href="#safety-tips">
                <div className="btn btn-outline">
                  <span>Safety Tips</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="rules-features-accordion">
        <div className="rules-container">
          <h2 className="community-rules---safety-section-title section-title">
            Listing Guidelines
          </h2>
          <p className="section-content">
            Everything you need to know about what flies and what doesn&apos;t
            in our bazaar.
          </p>
          <div className="accordion-group">
            <details open="true">
              <summary className="accordion-header">
                <div className="header-content">
                  <div className="icon-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                      ></path>
                    </svg>
                  </div>
                  <span>Allowed Listings &amp; Content Standards</span>
                </div>
              </summary>
              <div className="accordion-body">
                <p className="section-content">
                  We love unique items, local services, and cool gear. All
                  listings must be priced in DOGE (USD references are optional).
                  Photos must be original and accurately represent the item. No
                  stock photos for used goods, please!
                </p>
              </div>
            </details>
            <details>
              <summary className="accordion-header">
                <div className="header-content">
                  <div className="icon-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-5.5-3.5l-5 5m0-5l5 5"
                      ></path>
                    </svg>
                  </div>
                  <span>Prohibited Items &amp; Activities</span>
                </div>
              </summary>
              <div className="accordion-body">
                <p className="section-content">
                  Strictly forbidden: Illegal substances, weapons, hazardous
                  materials, counterfeit goods, and anything that violates local
                  laws. No &quot;get rich quick&quot; schemes or financial
                  services. We keep it physical and peer-to-peer.
                </p>
              </div>
            </details>
            <details>
              <summary className="accordion-header">
                <div className="header-content">
                  <div className="icon-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528"
                      ></path>
                    </svg>
                  </div>
                  <span>Takedowns &amp; Appeals Process</span>
                </div>
              </summary>
              <div className="accordion-body">
                <p className="section-content">
                  If a listing is reported and found in violation, it will be
                  removed instantly. We&apos;ll send you an email explaining
                  why. If you think we made a mistake (we&apos;re only
                  human/shibes), you can appeal through our support dashboard
                  within 48 hours.
                </p>
              </div>
            </details>
          </div>
        </div>
      </section>
      <section className="limits-product-accordion">
        <div className="limits-container">
          <h2 className="community-rules---safety-section-title section-title">
            Marketplace Integrity
          </h2>
          <p className="section-content">
            How we prevent spam and keep the bazaar running smoothly for
            everyone.
          </p>
          <div className="accordion-group">
            <details>
              <summary className="accordion-header">
                <div className="header-content">
                  <div className="icon-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M12 6v6l4 2m4-2v5m0 4h.01"></path>
                        <path d="M21.25 8.2A10 10 0 1 0 16 21.16"></path>
                      </g>
                    </svg>
                  </div>
                  <span>Posting Rate Limits</span>
                </div>
              </summary>
              <div className="accordion-body">
                <p className="section-content">
                  To prevent bot floods, new accounts are limited to 3 listings
                  per 24 hours. Established shibes (verified via local trade
                  history) can post up to 10 daily. Need more? Check out our
                  Power Seller options.
                </p>
              </div>
            </details>
            <details>
              <summary className="accordion-header">
                <div className="header-content">
                  <div className="icon-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 12v4m0 4h.01M17 18h.5a1 1 0 0 0 0-9h-1.79A7 7 0 1 0 7 17.708"
                      ></path>
                    </svg>
                  </div>
                  <span>Spam Prevention Tools</span>
                </div>
              </summary>
              <div className="accordion-body">
                <p className="section-content">
                  Our automated systems scan for duplicate content, suspicious
                  links, and rapid-fire messaging patterns. If you&apos;re
                  flagged, your content may go into a manual review queue.
                  Don&apos;t worry, real humans review these quickly!
                </p>
              </div>
            </details>
          </div>
        </div>
      </section>
      <section id="safety-tips" className="safety-about-accordion">
        <div className="safety-container">
          <h2 className="community-rules---safety-section-title section-title">
            Safety &amp; DOGE Best Practices
          </h2>
          <p className="section-content">
            Pro-tips for a smooth, non-custodial trading experience.
          </p>
          <div className="accordion-group">
            <details>
              <summary className="accordion-header">
                <div className="header-content">
                  <div className="icon-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                      </g>
                    </svg>
                  </div>
                  <span>Safe Meetups &amp; Local Trades</span>
                </div>
              </summary>
              <div className="accordion-body">
                <p className="section-content">
                  Always meet in well-lit, public places. Coffee shops,
                  libraries, or busy plazas are perfect. Bring a friend if
                  you&apos;re trading high-value items. Remember: Dogeet is
                  local-first, so keep it in the neighborhood!
                </p>
              </div>
            </details>
            <details>
              <summary className="accordion-header">
                <div className="header-content">
                  <div className="icon-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                        <path d="m9 11l3 3L22 4"></path>
                      </g>
                    </svg>
                  </div>
                  <span>Verifying DOGE Payments</span>
                </div>
              </summary>
              <div className="accordion-body">
                <p className="section-content">
                  Wait for at least 1 confirmation on the blockchain before
                  handing over the goods. Use a mobile wallet to show the
                  transaction hash. Since Dogeet is non-custodial, you are the
                  master of your own coin—no middleman, no chargebacks.
                </p>
              </div>
            </details>
            <details>
              <summary className="accordion-header">
                <div className="header-content">
                  <div className="icon-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092a10 10 0 1 0-4.777-4.719"
                      ></path>
                    </svg>
                  </div>
                  <span>Masked Messaging &amp; Privacy</span>
                </div>
              </summary>
              <div className="accordion-body">
                <p className="section-content">
                  Keep your initial conversations on the Dogeet platform. We use
                  masked email relays to protect your identity. Only share your
                  phone number or precise location when you&apos;re ready to
                  finalize the meetup.
                </p>
              </div>
            </details>
          </div>
        </div>
      </section>
      <section className="explore-local-accordion">
        <div className="community-rules---safety-explore-container">
          <h2 className="community-rules---safety-section-title section-title">
            Local Discovery Policies
          </h2>
          <p className="section-content">
            Why we prioritize your neighbors over long-distance shipping.
          </p>
          <div className="accordion-group">
            <details>
              <summary className="accordion-header">
                <div className="header-content">
                  <div className="icon-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M15 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 .445-.832l3-2a1 1 0 0 1 1.11 0l3 2A1 1 0 0 1 22 17v4a1 1 0 0 1-1 1zm3-12a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 .601.2M18 22v-3"></path>
                        <circle cx="10" cy="10" r="3"></circle>
                      </g>
                    </svg>
                  </div>
                  <span>Local Pickup vs. Shipping</span>
                </div>
              </summary>
              <div className="accordion-body">
                <p className="section-content">
                  Local trades are the heart of Dogeet. We strongly encourage
                  in-person exchanges to verify items and build community trust.
                  If you must ship, use tracked services and agree on DOGE
                  escrow (if available) or multi-sig setups.
                </p>
              </div>
            </details>
            <details>
              <summary className="accordion-header">
                <div className="header-content">
                  <div className="icon-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092a10 10 0 1 0-4.777-4.719M8 12h.01M12 12h.01M16 12h.01"
                      ></path>
                    </svg>
                  </div>
                  <span>Community Expectations</span>
                </div>
              </summary>
              <div className="accordion-body">
                <p className="section-content">
                  Be punctual, be polite, and be fair. Dogeet is built on the
                  &quot;Do Only Good Everyday&quot; mantra. Lowballing is part
                  of the game, but harassment is not. Treat every neighbor like
                  a fellow shibe.
                </p>
              </div>
            </details>
          </div>
        </div>
      </section>
      <section id="reporting" className="reporting-steps-vertical">
        <div className="reporting-container">
          <h2 className="community-rules---safety-section-title section-title">
            How to Report &amp; Resolve
          </h2>
          <p className="section-content">
            See something, say something. Here is how we handle issues in the
            bazaar.
          </p>
          <div className="steps-list">
            <div className="community-rules---safety-step-item">
              <div className="community-rules---safety-step-number">
                <span>1</span>
              </div>
              <div className="step-content">
                <h3 className="section-subtitle">Flag the Listing</h3>
                <p className="section-content">
                  Click the &quot;Report&quot; button on any listing page.
                  Select the reason (Spam, Prohibited, Scam, etc.) and provide a
                  brief description of the issue.
                </p>
              </div>
            </div>
            <div className="community-rules---safety-step-item">
              <div className="community-rules---safety-step-number">
                <span>2</span>
              </div>
              <div className="step-content">
                <h3 className="section-subtitle">Initial Review</h3>
                <p className="section-content">
                  Our moderation bot performs an instant check for
                  high-confidence violations. If it&apos;s a clear breach, the
                  listing is hidden immediately pending human review.
                </p>
              </div>
            </div>
            <div className="community-rules---safety-step-item">
              <div className="community-rules---safety-step-number">
                <span>3</span>
              </div>
              <div className="step-content">
                <h3 className="section-subtitle">Human Verification</h3>
                <p className="section-content">
                  A community moderator reviews the report within 12-24 hours.
                  We may contact you for more details or proof of a failed
                  trade.
                </p>
              </div>
            </div>
            <div className="community-rules---safety-step-item">
              <div className="community-rules---safety-step-number">
                <span>4</span>
              </div>
              <div className="step-content">
                <h3 className="section-subtitle">Final Action</h3>
                <p className="section-content">
                  We take action: removal, account warning, or permanent ban.
                  You&apos;ll receive a notification once the case is closed.
                  Much resolution!
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="contact-faq-accordion">
        <div className="contact-container">
          <h2 className="community-rules---safety-section-title section-title">
            Quick Help &amp; Resources
          </h2>
          <p className="section-content">
            Can&apos;t find what you&apos;re looking for? Check these common
            questions.
          </p>
          <div className="accordion-group">
            <details>
              <summary className="accordion-header">
                <div className="header-content">
                  <div className="icon-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3m.08 4h.01"></path>
                      </g>
                    </svg>
                  </div>
                  <span>Is Dogeet an Escrow service?</span>
                </div>
              </summary>
              <div className="accordion-body">
                <p className="section-content">
                  No. Dogeet is non-custodial. We facilitate the discovery and
                  messaging, but the actual DOGE transfer happens directly
                  between your wallets. We never touch your coins.
                </p>
              </div>
            </details>
            <details>
              <summary className="accordion-header">
                <div className="header-content">
                  <div className="icon-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 13h.01M12 6v3M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                      ></path>
                    </svg>
                  </div>
                  <span>Where can I find the full Moderation FAQ?</span>
                </div>
              </summary>
              <div className="accordion-body">
                <p className="section-content">
                  You can view our deep-dive documentation at
                  docs.dogeet.com/moderation. It covers edge cases, community
                  voting, and becoming a moderator.
                </p>
              </div>
            </details>
          </div>
          <div className="contact-footer">
            <p className="section-content">
              Still need help? Reach out to our support shibes.
            </p>
            <a href="mailto:contact@dogeet.com?subject=">
              <div className="btn btn-secondary">
                <span>Contact Support</span>
              </div>
            </a>
          </div>
        </div>
      </section>
      <div className="community-rules-safety-container23">
        <div className="community-rules-safety-container24">
          <Script
            html={`<style>
details {
  background: var(--color-surface-elevated);
  border-radius: var(--border-radius-lg);
  border: 1px solid var(--color-border);
  overflow: hidden;
  transition: all 0.3s ease;
}
details[open] {
  border-color: var(--color-primary);
  box-shadow: 0 8px 24px color-mix(in srgb, var(--color-primary) 10%, transparent);
}
summary {
  list-style: none;
  cursor: pointer;
  padding: var(--spacing-xl);
  user-select: none;
}
summary::-webkit-details-marker {
  display: none;
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="community-rules-safety-container25">
        <div className="community-rules-safety-container26">
          <Script
            html={`<script defer data-name="accordion-enhancements">
(function(){
  // Handle smooth animation for details elements
  const detailsElements = document.querySelectorAll('details');
  
  detailsElements.forEach((targetDetail) => {
    targetDetail.addEventListener('click', (e) => {
      // If we want to implement a "one-at-a-time" accordion behavior
      // we can uncomment the following logic:
      /*
      if (targetDetail.hasAttribute('open')) return;
      
      detailsElements.forEach((detail) => {
        if (detail !== targetDetail) {
          detail.removeAttribute('open');
        }
      });
      */
    });
  });

  // Simple scroll reveal observer
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        revealObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.step-item, details').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'all 0.5s ease-out';
    revealObserver.observe(el);
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default CommunityRulesSafety
